import { createContext } from "react";
export var AuthContext = createContext(void 0);